"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Repository = void 0;
var react3l_axios_observable_1 = require("react3l-axios-observable");
var operators_1 = require("rxjs/operators");
var Repository = /** @class */ (function () {
    /**
     * Class constructor
     *
     * @param config - AxiosRequestConfig
     */
    function Repository(config) {
        this.http = react3l_axios_observable_1.Axios.create(config);
        Repository.addInstance(this);
        var requestInterceptor = Repository.requestInterceptor, responseInterceptor = Repository.responseInterceptor, errorInterceptor = Repository.errorInterceptor;
        if (typeof requestInterceptor === 'function') {
            this.http.interceptors.request.use(requestInterceptor);
        }
        if (typeof responseInterceptor === 'function') {
            this.http.interceptors.response.use(responseInterceptor);
        }
        if (typeof errorInterceptor === 'function') {
            this.http.interceptors.response.use(undefined, errorInterceptor);
        }
    }
    Object.defineProperty(Repository, "repositoryInstances", {
        /**
         * Repository instances
         *
         * @type {Repository[]}
         */
        get: function () {
            return this.instances;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Repository.prototype, "baseURL", {
        get: function () {
            return this.http.defaults.baseURL;
        },
        set: function (baseURL) {
            this.http.defaults.baseURL = baseURL;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Map a http response to list of ModelClass
     *
     * @param ModelClass {typeof Model}
     */
    Repository.responseMapToList = function (ModelClass) {
        return operators_1.map(function (response) {
            var _a;
            return (_a = response.data) === null || _a === void 0 ? void 0 : _a.map(function (data) {
                var instance = ModelClass.create();
                Object.assign(instance, data);
                return instance;
            });
        });
    };
    /**
     * Map a http response to a ModelClass
     *
     * @param ModelClass {typeof Model}
     */
    Repository.responseMapToModel = function (ModelClass) {
        return operators_1.map(function (response) {
            var instance = ModelClass.create();
            Object.assign(instance, response.data);
            return instance;
        });
    };
    /**
     * Get response data as type T
     */
    Repository.responseDataMapper = function () {
        return operators_1.map(function (response) { return response.data; });
    };
    Repository.addInstance = function (instance) {
        this.instances.push(instance);
    };
    /**
     * Repository instances
     *
     * @protected
     * @type {Repository[]}
     */
    Repository.instances = [];
    return Repository;
}());
exports.Repository = Repository;
//# sourceMappingURL=Repository.js.map